import { render, staticRenderFns } from "./CustomSearch.vue?vue&type=template&id=4a09b5b3&scoped=true"
import script from "./CustomSearch.vue?vue&type=script&lang=ts"
export * from "./CustomSearch.vue?vue&type=script&lang=ts"
import style0 from "./CustomSearch.vue?vue&type=style&index=0&id=4a09b5b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a09b5b3",
  null
  
)

export default component.exports